import type { IconProps } from './types';

export const ChevronRightDoubleIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M3.09375 2.15625L12.9375 12L3.09375 21.8438M10.5938 2.15625L20.4375 12L10.5938 21.8438"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
